export const EXCLUDED_STORE_ATTR_PREFIXES = ["DPT_", "DPS_", "DPV_"];

export const isExcludedStoreAttribute = (name?: string): boolean =>
  !!name && EXCLUDED_STORE_ATTR_PREFIXES.some((prefix) => name.startsWith(prefix));

export const isExcludedAttribute = (attribute?: {
  name?: string;
  identifier?: string;
  value?: string;
  extendedData?: { fname?: string; propertyvalue?: string };
}): boolean =>
  isExcludedStoreAttribute(attribute?.name) ||
  isExcludedStoreAttribute(attribute?.identifier) ||
  isExcludedStoreAttribute(attribute?.value) ||
  isExcludedStoreAttribute(attribute?.extendedData?.fname) ||
  isExcludedStoreAttribute(attribute?.extendedData?.propertyvalue);

export const dedupeRibbonAttributes = (attributes: any[] = []): any[] => {
  const seen = new Set<string>();
  return (attributes || []).filter((attribute) => {
    const key =
      attribute?.values?.[0]?.value ??
      attribute?.identifier ??
      attribute?.name;
    if (key === undefined || key === null || seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};
